import React from 'react';
import styled from 'styled-components';
import { displayPercent } from './salesTokens';

/**
 * Barra de progresso de vendas.
 *
 * - expõe `role="progressbar"` + aria-valuenow e um rótulo textual, então
 *   leitores de tela anunciam "12 de 300 vendidos" em vez de ignorar a barra;
 * - a cor vem do tom semântico (baixa venda ≠ verde de sucesso);
 * - `min-width` no preenchimento garante que 0,4% ainda apareça como um traço,
 *   em vez de sumir e parecer venda zero.
 */
export default function SalesBar({ percent = 0, tone, height = 10, label }) {
    const clamped = Math.min(Math.max(percent, 0), 100);

    return (
        <Track
            $tone={tone}
            $height={height}
            role='progressbar'
            aria-valuenow={displayPercent(clamped)}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={label}
        >
            <Fill $tone={tone} $percent={clamped} />
        </Track>
    );
}

const Track = styled.div`
    position: relative;
    width: 100%;
    height: ${({ $height }) => $height}px;
    border-radius: 999px;
    background: ${({ $tone }) => $tone.track};
    overflow: hidden;
`;

const Fill = styled.div`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    min-width: ${({ $percent }) => ($percent > 0 ? '5px' : '0')};
    border-radius: 999px;
    background: ${({ $tone }) => $tone.fill};
    transition: width 0.7s cubic-bezier(0.22, 1, 0.36, 1);
`;
